function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M23.5,23H23V13.5a.5.5,0,0,0-.5-.5H20v-.5a.5.5,0,0,0-1,0V13h-.5a.5.5,0,0,0-.5.5V23H17V4.5a.5.5,0,0,0-.5-.5H14V2.5a.5.5,0,0,0-.5-.5H13V.5a.5.5,0,0,0-1,0V2H10.5a.5.5,0,0,0-.5.5V4H7.5a.5.5,0,0,0-.5.5V23H6V13.5a.5.5,0,0,0-.5-.5H5v-.5a.5.5,0,0,0-1,0V13H1.5a.5.5,0,0,0-.5.5V23H.5a.5.5,0,0,0,0,1h23a.5.5,0,0,0,0-1ZM11,3h2V4H11ZM2,23V14H5v9Zm6,0V5h8V23Zm11,0V14h3v9ZM15,7.5a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,7.5Zm0,3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,10.5Zm0,3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,13.5Zm0,3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,16.5Zm0,3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,19.5Z"
})));

var SvgCompany = function SvgCompany(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCompany, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company.19cb67ec.svg";
export { ForwardRef as ReactComponent };